import { client } from "antdash";

const list = () => client.get("tracking_groups");

const trackingGroupsApi = {
  list,
};

export default trackingGroupsApi;
